import { FC } from 'react';
import { AllFbtItems } from 'services/fbtItems/types';
import { CatHeading } from 'components/blocks-components';
import { ProductDealerPriceAvailability } from 'services/dealerPriceAvailability/types';
import { CustomStyledLabel } from '@cat-ecom/pcc-components';
import { useTranslations } from 'next-intl';
import FBTProductList from './fbt-content-item';
import styles from './fbt-mobile-drawer-content.module.scss';

interface FbtContentProps {
  products: AllFbtItems[];
  partsPriceData: ProductDealerPriceAvailability[];
  currency: string;
  isCatCorp: boolean;
  frequestBoughtMobile: boolean;
  contactDealerComp: React.ReactNode;
  handleCheckboxChange?: (
    e: CustomEvent<{ checked: boolean; indeterminate: boolean; value: string }>
  ) => void;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
  cartId: string;
  storeLocationId: string;
}

export const FBTDrawerContent: FC<FbtContentProps> = ({
  products,
  partsPriceData,
  currency,
  isCatCorp,
  frequestBoughtMobile,
  handleCheckboxChange,
  contactDealerComp,
  storeLocationId,
  isRTL = false,
  cartId,
  currencyLdFeatureFlag = false
}) => {
  const t = useTranslations();
  return (
    <>
      <CatHeading className="text-capitalize" variant="label">
        <CustomStyledLabel className={styles['cat-heading']}>
          {t('FREQUENTLY_BOUGHT_TOGETHER')}
        </CustomStyledLabel>
      </CatHeading>

      <FBTProductList
        products={products}
        partsPriceData={partsPriceData}
        currency={currency}
        isCatCorp={isCatCorp}
        frequestBoughtMobile={frequestBoughtMobile}
        handleCheckboxChange={handleCheckboxChange}
        contactDealerComp={contactDealerComp}
        isRTL={isRTL}
        currencyLdFeatureFlag={currencyLdFeatureFlag}
        cartId={cartId}
        startIndex={2}
        storeLocationId={storeLocationId}
      />
    </>
  );
};

export default FBTDrawerContent;
